import controller from './payment-cart.controller';
import template from './payment-cart.view.html';

let PaymentCartComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default PaymentCartComponent;


/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payment-cart/payment-cart.component.js
 **/